module.exports = __webpack_public_path__ + "static/achievement-female-2b174f3b4ca0a5ec67d7a121ef7c7bcc.png";